<div class="container-fluid mt-4 px-4">
    <app-custom-table-title
        icon="verified_user"
        title="Autorizaciones Verifactu"
        subTitle="Gestiona las autorizaciones de tus clientes para operar bajo Verifactu">
    </app-custom-table-title>
    <div class="card shadow-sm">
        <div class="card-body p-4">

            <div class="row">
                <div class="col-md-2 col-sm-12 mb-3">
                    <div class="nav flex-column nav-pills" role="tablist">
                        <a class="nav-link py-1 px-2 small" [ngClass]="{ 'active': activeTab === 'pending' }"
                            (click)="activeTab = 'pending'">
                            Pendientes validar
                        </a>

                        <a class="nav-link py-1 px-2 small" [ngClass]="{ 'active': activeTab === 'validateds' }"
                            (click)="activeTab = 'validateds'">
                            Autorizaciones
                        </a>

                        <a class="nav-link py-1 px-2 small" [ngClass]="{ 'active': activeTab === 'revokeds' }"
                            (click)="activeTab = 'revokeds'">
                            Revocadas
                        </a>
                    </div>
                </div>

                <div class="col-md-10 col-sm-12">
                    <div class="tab-content">
                        <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'pending' }" id="pending">
                            <div *ngIf="!authsPendings || authsPendings.length === 0"
                                class="alert alert-info text-center">
                                No hay autorizaciones pendientes de validar en este momento.
                            </div>
                            <admin-verifactu-authorization-list [(auths)]="authsPendings" (revokeRequested)="onRevoke($event)"
                                (validateRequested)="onValidate($event)"
                                (downloadRequested)="getDocument($event)"></admin-verifactu-authorization-list>
                        </div>
                        <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'validateds' }"
                            id="validateds">
                            <admin-verifactu-authorization-list [(auths)]="authsValidateds"
                                (revokeRequested)="onRevoke($event)"
                                (downloadRequested)="getDocument($event)"></admin-verifactu-authorization-list>
                        </div>

                        <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'revokeds' }"
                            id="revokeds">
                            <admin-verifactu-authorization-list [(auths)]="authsRevokeds"
                                (downloadRequested)="getDocument($event)"></admin-verifactu-authorization-list>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>